var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImplicationArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.079,
    height: 18.217,
    viewBox: "0 0 31.079 18.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3754",
    "data-name": "Group 3754",
    transform: "translate(6.332 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953",
    transform: "translate(10.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M5.179,5.136,0,0V5.262L2.546,7.789l.022.023a1.851,1.851,0,0,1,0,2.593l-.022.023L0,12.955v5.262l5.179-5.136c.038-.035.06-.078.1-.113L9.079,9.109,5.274,5.249c-.035-.035-.057-.078-.1-.113",
    transform: "translate(5.128 4)",
    fill: "#006ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M5.179,5.136,0,0V5.262L2.546,7.789l.022.023a1.851,1.851,0,0,1,0,2.593l-.022.023L0,12.955v5.262l5.179-5.136c.038-.035.06-.078.1-.113L9.079,9.109,5.274,5.249c-.035-.035-.057-.078-.1-.113",
    transform: "translate(-5.872 4)",
    fill: "#006ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M5.179,5.136,0,0V5.262L2.546,7.789l.022.023a1.851,1.851,0,0,1,0,2.593l-.022.023L0,12.955v5.262l5.179-5.136c.038-.035.06-.078.1-.113L9.079,9.109,5.274,5.249c-.035-.035-.057-.078-.1-.113",
    transform: "translate(-16.872 4)",
    fill: "#006ad9"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplicationArrows);
export default __webpack_public_path__ + "static/media/implicationArrows.bcb12f8efafa23c5c84100d07352e5b5.svg";
export { ForwardRef as ReactComponent };